import React from 'react'
import { Linha } from './styles'

const Line: React.FC = () => {
  return <Linha />
}

export default Line
